const TERMINAL_JOB_STATUSES = ['SUCCESS', 'ERROR', 'DEAD', 'DUPLICATE'];

export const isJobRunning = (job) =>
  !job.status || !TERMINAL_JOB_STATUSES.includes(job.status);
export const isJobCompleted = (job) =>
  TERMINAL_JOB_STATUSES.includes(job.status);
export const isJobSuccessful = (job) => job.status === 'SUCCESS';
